import { clearEngravingPos, updateChoice } from "areas/product/store/actions"

const limitChars = (
  engraving,
  event,
  dispatch,
  setFastEngravingValue = null,
  updateEngravingCount = false
) => {
  if (!engraving?.pref) {
    console.error("limitChars called with missing engraving pref", engraving)
    return
  }

  let selectedFont, styleCode
  try {
    if (event && event.persist) {
      event.persist()
    }

    let state = null

    if (!styleCode) {
      state = appStoreV2.getState()
      if (state.choices.style_code) {
        styleCode = state.choices.style_code?.value
      }
    }
    try {
      if (!selectedFont) {
        if (!state) {
          state = appStoreV2.getState()
        }
        selectedFont = state.choices[engraving.engraving_font || "ef"]
          ? state.choices[engraving.engraving_font || "ef"].value
          : ""
      }
    } catch (e) {
      // Silently proceed
    }

    let font_specific_overrides =
      engraving.font_specific_overrides?.[selectedFont] || {}
    let limit = engraving.max_chars
    let caps = font_specific_overrides?.letter_case ?? engraving.caps
    let text = event ? event.target.value : engraving.value
    let textlength = [...text].length
    const allow_cap_heart_cap =
      font_specific_overrides?.allow_cap_heart_cap ??
      engraving.allow_cap_heart_cap

    //regex = (regex + regexend);

    let regex = engraving.pattern
    let allow_emojis = engraving.allow_emojis

    if (font_specific_overrides?.is_hebrew_font) {
      if (font_specific_overrides.pattern) {
        regex = font_specific_overrides.pattern
      }
      if (font_specific_overrides.allow_emojis !== undefined) {
        allow_emojis = font_specific_overrides.allow_emojis
      }
    }

    if (allow_emojis || allow_cap_heart_cap) {
      if (engraving.allow_emoji_values) {
        regex =
          regex.substr(0, regex.length - 1) + engraving.allow_emoji_values + "]"
      } else {
        regex = regex.substr(0, regex.length - 1) + sl.emoji_regex + "]"
      }
    }

    let newText = text

    if (regex) {
      // unescape the regex in ruby format
      regex = regex.replace(/\\#/g, "#")
      newText = text.replace(new RegExp(regex, "uig"), "")
    }

    // Adjust case
    if (!engraving.any_case) {
      if (caps == "All Caps") {
        newText = newText.toUpperCase()
      } else if (
        caps == "Title Caps" ||
        (caps == "Loose Title Caps" && newText[0]?.isUpperCase())
      ) {
        newText = allow_cap_heart_cap
          ? newText.titleCaseWithHeart()
          : newText.titleCase()
      } else if (caps == "No Caps" || caps == "Loose Title Caps") {
        newText = newText.toLowerCase()
      } else if (caps == "Any" && engraving.max_uppercase_chars) {
        const uppercaseLetterIndexes = newText.uppercaseLetterIndexes()
        if (
          engraving.max_uppercase_chars &&
          uppercaseLetterIndexes.length > engraving.max_uppercase_chars
        ) {
          const splitIndex =
            uppercaseLetterIndexes[engraving.max_uppercase_chars - 1]
          newText =
            newText.substring(0, splitIndex + 1) +
            newText.substring(splitIndex + 1).toLowerCase()
        }
      }
      // Apply Title Case for Snell font
      // TODO: Don't use window.appStoreV2
    }

    if (selectedFont != "") {
      if (
        selectedFont != undefined &&
        (selectedFont.indexOf("Cursive") != -1 ||
          selectedFont.indexOf("Scriptee") != -1) &&
        caps != "All Caps" &&
        caps != "No Caps" &&
        !engraving.any_case &&
        !allow_cap_heart_cap
      ) {
        // Set to lowercase or titlecase
        newText = newText
          .split(" ")
          .map((l) => l.charAt(0) + l.slice(1).toLowerCase())
          .join(" ")
      }

      // Arabic/Farsi hack, increase the textLength if the value doesn't match
      // these particular pairs
      if (
        selectedFont == "Arabic" &&
        !["أو", "او", "اُ", "اَ", "اِ"].includes(newText)
      ) {
        textlength++
        limit--
      }
    }

    // Remove Emojis
    // newText = newText.replace(/[\uD800-\uDBFF\uDC00-\uDFFF]/g, "")

    // When `max_chars: 1`, allow heart emojis (i.e. ❤️ or ♥️) which take up two characters logically but one character visually
    const startWithHeartEmoji = new RegExp(
      "^(\u2764\ufe0f|\u2665\ufe0f)",
      "u"
    ).test(newText)
    if (limit == 1 && startWithHeartEmoji) {
      limit = 2
    }

    if (textlength > limit) {
      newText = [...newText].slice(0, limit).join("")
      if (event) {
        event.target.classList.add("animate-shake")
        event.target.addEventListener("animationend", function () {
          event.target.classList.remove("animate-shake")
        })
      }
    }

    dispatch(clearEngravingPos(engraving.pref))
    if (setFastEngravingValue) {
      setFastEngravingValue(newText)
    } else if (updateEngravingCount) {
      dispatch(
        updateChoice(
          engraving.pref,
          Object.assign({}, engraving, {
            price: newText.length == 0 ? 0 : engraving.price || 0,
            updateCount: (engraving.updateCount || 0) + 1,
            value: newText,
          }),
          false
        )
      )
    } else if (newText.length == 0) {
      dispatch(
        updateChoice(engraving.pref, {
          disabled: engraving.disabled || false,
          is_default: engraving.is_default || false,
          price: 0,
          value: newText,
        })
      )
    } else {
      let prefData = {
        value: newText,
      }
      dispatch(
        updateChoice(
          engraving.pref,
          Object.assign({}, engraving, prefData),
          allow_cap_heart_cap
        )
      )
    }
    // engravingInputElement.val(newText);
    // if (typeof event !== 'undefined') restoreCursorPos(event, pos);

    // Update characters remaining
    // let charsLeft = limit - newText.length;
    // $(event.target).parents('.engraving-entry').find(".engraving-chars-text").text(charsLeft + " left");
  } catch (e) {
    console.log("error with limitChars", e)
  }
} // end limitChars

export default limitChars
